export const handelOpenModalEditProfile = () => ({
    type: 'OPEN_MODAL_EDIT_PROFILE'
});
export const handelCloseModalEditProfile = () => ({
    type: 'CLOSE_MODAL_EDIT_PROFILE'
});
export const changeInputsModalEditProfile = (name,value) => ({
    type: 'CHANGE_INPUTS_MODAL_EDIT_PROFILE',name,value
});
export const changeValidatedModalEitProfile = (name,validated) => ({
    type: 'CHANGE_VALIDATED_MODAL_EDIT_PROFILE',name,validated
});
export const ChangeLoaderPostModalEditProfile = (loaderStatus) => ({
    type: 'LOADER_POST_MODAL_EDIT_PROFILE',loaderStatus
});
